export default __webpack_public_path__ + "media/images/dashboard_icons/giftlist-820cb19c6bc68caac5ae554b1fe1a135.svg";